import styled from 'styled-components';

interface InputProps {
  error?: boolean;
}

export const Container = styled.div<InputProps>`
  display: flex;
  flex-direction: column;
  margin: 14px;

  label {
    margin: 2px 5px;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    color: #707070;
  }

  input {
    margin-top: 6px;
    padding: 16px;
    height: 30px;
    border: ${(props) =>
      props.error ? ' 2px solid #ff0000' : ' 1px solid #dcdcdc'};
    border-radius: 5px;
    background-color: #fff;
    color: #707070;
  }
`;
